import { Component, Input } from '@angular/core';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'ui-new-feature-tooltip',
  templateUrl: './new-feature-tooltip.component.html',
  styleUrls: ['./new-feature-tooltip.component.scss'],
})
export class NewFeatureTooltip {
  @Input() tooltipHeader = '';
  @Input() tooltipTxt = '';

  constructor(private modalConbtroller: ModalController) {}

  dismissPopover() {
    this.modalConbtroller.dismiss();
  }
}
